<div class="date-range-picker">
  <!-- Header with navigation arrows -->
  <div class="calendar-header">
    <ion-button fill="clear" (click)="navigateMonth('prev')" class="nav-button">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </ion-button>

    <div class="month-display">
      <span class="month-label">{{ currentMonth | date: "MMMM yyyy" }}</span>
      <span class="month-label">{{ nextMonth | date: "MMMM yyyy" }}</span>
    </div>

    <ion-button fill="clear" (click)="navigateMonth('next')" class="nav-button">
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>

  <!-- Main content area -->
  <div class="picker-content">
    <!-- Left side - Preset ranges -->
    <!-- Hiding this for now because it requires special handling in the callback -->
    <!-- <div class="preset-sidebar">
      <div class="preset-list">
        <div 
          *ngFor="let preset of presetRanges; let i = index"
          class="preset-option"
          [ngClass]="{ 'selected': i === selectedPresetIndex }"
          (click)="selectPresetRange(i)"
        >
          {{ preset.label }}
        </div>
      </div>
    </div> -->

    <!-- Right side - Calendars -->
    <div class="calendars-container">
      <!-- First calendar -->
      <div class="calendar">
        <div class="calendar-header-row">
          <span
            class="day-header"
            *ngFor="
              let day of ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
            "
          >
            {{ day }}
          </span>
        </div>

        <div class="calendar-grid">
          <div
            *ngFor="let date of getCalendarDays(currentMonth)"
            class="calendar-day"
            [ngClass]="{
              'other-month': !isCurrentMonth(date, currentMonth),
              'in-range': isSelectingStartDate && isDateInRange(date),
              'start-date': isStartDate(date),
              'end-date': isSelectingStartDate && isEndDate(date),
              clickable: isCurrentMonth(date, currentMonth)
            }"
            (click)="selectDate(date)"
          >
            {{ date | date: "d" }}
          </div>
        </div>
      </div>

      <!-- Second calendar -->
      <div class="calendar">
        <div class="calendar-header-row">
          <span
            class="day-header"
            *ngFor="
              let day of ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
            "
          >
            {{ day }}
          </span>
        </div>

        <div class="calendar-grid">
          <div
            *ngFor="let date of getCalendarDays(nextMonth)"
            class="calendar-day"
            [ngClass]="{
              'other-month': !isCurrentMonth(date, nextMonth),
              'in-range': isSelectingStartDate && isDateInRange(date),
              'start-date': isStartDate(date),
              'end-date': isSelectingStartDate && isEndDate(date),
              clickable: isCurrentMonth(date, nextMonth)
            }"
            (click)="selectDate(date)"
          >
            {{ date | date: "d" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="picker-footer">
    <div class="footer-center">
      <div class="date-inputs">
        <ion-input
          type="date"
          [value]="getFormattedDate(currentDateRange.startDate)"
          (ionChange)="onStartDateChange($event)"
          class="date-input"
          placeholder="Start Date"
        ></ion-input>
        <span class="date-separator">to</span>
        <ion-input
          type="date"
          [value]="getFormattedDate(currentDateRange.endDate)"
          (ionChange)="onEndDateChange($event)"
          class="date-input"
          placeholder="End Date"
          [ngClass]="{ 'highlighted-date-range': !isSelectingStartDate }"
        ></ion-input>
      </div>
    </div>

    <div class="footer-right">
      <ion-button fill="clear" class="button-dark-border" (click)="cancel()">
        Cancel
      </ion-button>
      <ion-button
        (click)="update()"
        [disabled]="!currentDateRange.startDate || !currentDateRange.endDate"
      >
        Apply
      </ion-button>
    </div>
  </div>
</div>
